import {
  IAdvancedRulesClient,
  IFieldsMap,
} from "@common/redux/formBuilder/interface";
import { IOption } from "@erelego/design-system/components/atoms/DropdownSelect/component/OptionItem";
import { FieldProps, FormFieldTypes } from "../FormFieldSelector/interfaces";
import {
  IFieldLevelRuleConditionMap,
  IFieldLevelRuleClient,
  IFieldLevelRuleActionServer,
  IPageLevelRuleConditionMap,
  IPageLevelRuleAction,
  IPageLevelRuleConditionClient,
  IFormLevelRuleClient,
  IFormLevelRuleConditionClient,
  IFormLevelRuleConditionMap,
  IFormLevelRuleActionServer,
} from "@common/redux/forms/interface";
import { ICheckBoxData } from "@erelego/design-system/components/molecules/MultiSelectDropdown/components/CheckBoxsContainer";
import { IPageLevelRuleClient } from "../ConfiguredRule/interface";
import { ConditionType } from "@erelego/design-system/components/molecules/ConditionFilters/utils";

export const getFilteredFieldsnameAndIdSelector = (
  fieldsMap: IFieldsMap,
  fieldIdsIgnore: string[],
  fieldTypesToIgnore: string[]
): IOption[] => {
  const filteredFieldOptions = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];
    const {
      title = "",
      localId,
      isSection,
      fieldType = "",
      fields,
      parentFormId,
      name = "",
    } = fieldData;

    const checkIsSection =
      isSection || fieldType == FormFieldTypes?.SECTION || false;
    if (
      !fieldIdsIgnore.includes(key) &&
      !checkIsSection &&
      !fieldTypesToIgnore.includes(fieldType)
    ) {
      filteredFieldOptions.push({
        content: name || title || "Untitled field",
        value: key,
        fieldType,
        parentFormId,
        localId,
        title: title || "Untitled field",
        // subtitle: fieldType || "",//can be used for better UX
      });
    }
  });
  return filteredFieldOptions;
};
export const getFilteredFieldsnameAndIdSelectorForAction = (
  fieldsMap: IFieldsMap,
  fieldIdsIgnore: string[],
  fieldTypesToIgnore: string[]
): ICheckBoxData[] => {
  const filteredFieldOptions = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];
    const {
      title = "",
      name = "",
      localId,
      isSection,
      fieldType = "",
      fields,
      parentFormId,
    } = fieldData;

    // const checkIsSection = isSection || fieldType == FormFieldTypes?.SECTION || false;
    if (
      !fieldIdsIgnore.includes(key) &&
      // !checkIsSection &&
      !fieldTypesToIgnore.includes(fieldType)
    ) {
      filteredFieldOptions.push({
        content: name || title || "Untitled field",
        value: key,
        fieldType,
        parentFormId,
        localId,
        title: name || title || "Untitled field",
        // subtitle: fieldType || "",//can be used for better UX
      });
    }
  });
  return filteredFieldOptions;
};
export const emptyCondition = {
  operator: "",
  value: "",
  fieldType: "",
  fieldLocalId: "",
};
export const emptyActions = {
  fieldType: "",
  fieldLocalId: "",
  subFormLocalId: "",
  visibility: "SHOW",
};
export const showHideFieldOptions = [
  {
    content: "Show",
    value: "SHOW",
  },
  {
    content: "Hide",
    value: "HIDE",
  },
];
export enum showHideFieldOptionsEnum {
  SHOW = "SHOW",
  HIDE = "HIDE",
}
export enum showHideFieldOptionsNameEnum {
  SHOW = "Show",
  HIDE = "Hide",
}
export const fieldConstraint = (fieldType: string): IOption[] => {
  const constraint = constraintConfigs[fieldType] || {};
  const inputConstraint = Object.keys(constraint).map((key: string) => ({
    content: allConstraintNames[key],
    value: key,
  }));
  return inputConstraint;
};
export const ignoredFieldType = [
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.CHECK_BOX,
  FormFieldTypes.DATE_TIME_PICKER,
  FormFieldTypes.PAYMENT,
  FormFieldTypes.NUMBER_INPUT,
  FormFieldTypes.CALCULATIVE,
  FormFieldTypes.BLANK_BOX,
  FormFieldTypes.DATA_GRID,
  FormFieldTypes.PAYMENT,
  FormFieldTypes.GEOLOCATION,
];

export const ignoredFieldTypeForInfographics = [
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.SECTION,
  FormFieldTypes.DESCRIPTION,
  FormFieldTypes.PAGE_BREAK,
  FormFieldTypes.DECIMAL,
  FormFieldTypes.BLANK_BOX,
  FormFieldTypes.DATA_GRID,
  FormFieldTypes.BANNER,
];

export const ignoredFieldConditionType = [
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.BLANK_BOX,
  FormFieldTypes.DATA_GRID,
  FormFieldTypes.DESCRIPTION,
  FormFieldTypes.PAGE_BREAK,
  FormFieldTypes.SECTION,
  FormFieldTypes.BANNER,
];
export const ignoredFieldActionType = [FormFieldTypes.BLANK_BOX];

export const ignoredBarChartInfographicFieldType = [
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.TEXT_AREA,
  // FormFieldTypes.SECTION,
  FormFieldTypes.PAYMENT, //CONFIG NOT ADDED IN BE
  FormFieldTypes.GEOLOCATION, //CONFIG NOT ADDED IN BE
];

export const ignoredPieInfographicFieldType = [
  FormFieldTypes.TEXT_AREA,
  FormFieldTypes.PAYMENT,
  FormFieldTypes.DATE_INPUT,
  FormFieldTypes.TIME_PICKER,
  FormFieldTypes.DATE_TIME_PICKER,
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.GEOLOCATION, //CONFIG NOT ADDED IN BE
  FormFieldTypes.DOUBLE_PANEL,
];
export const ignoredInfographicFieldType = [
  FormFieldTypes.TEXT_AREA,
  FormFieldTypes.PAYMENT,
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.GEOLOCATION, //CONFIG NOT ADDED IN BE
];
export const infographicAggregationField = [
  FormFieldTypes.TEXT_INPUT,
  FormFieldTypes.DROPDOWN,
  FormFieldTypes.MULTIPLE_CHOICES,
  FormFieldTypes.TEXT_AREA,
  FormFieldTypes.DATE_INPUT,
  FormFieldTypes.TIME_PICKER,
  FormFieldTypes.LINEAR_SCALING,
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.RATING,
  FormFieldTypes.DATE_TIME_PICKER,
  FormFieldTypes.CHECK_BOX,
  FormFieldTypes.DECIMAL,
  FormFieldTypes.DECISION_BOX,
  FormFieldTypes.PAGE_BREAK,
  FormFieldTypes.PAYMENT,
  FormFieldTypes.SECTION,
  FormFieldTypes.GEOLOCATION, //CONFIG NOT ADDED IN BE
  FormFieldTypes.SIGNATURE_BOX,
  FormFieldTypes.DOUBLE_PANEL,
];
export const ignoredInfographicFieldSummary = [
  FormFieldTypes.TEXT_INPUT,
  FormFieldTypes.TEXT_AREA,
  FormFieldTypes.FILE_UPLOAD,
  FormFieldTypes.DECIMAL,
  FormFieldTypes.PAGE_BREAK,
  FormFieldTypes.SECTION,
  FormFieldTypes.DESCRIPTION,
  FormFieldTypes.BLANK_BOX,
  FormFieldTypes.DATA_GRID,
  FormFieldTypes.GEOLOCATION, //CONFIG NOT ADDED IN BE
  FormFieldTypes.SIGNATURE_BOX,
  FormFieldTypes.BANNER,
  // FormFieldTypes.DATE_INPUT,
  // FormFieldTypes.TIME_PICKER,
  // FormFieldTypes.LINEAR_SCALING,
  // FormFieldTypes.CURRENCY,
  // FormFieldTypes.RATING,
  // FormFieldTypes.DATE_TIME_PICKER,
  // FormFieldTypes.CHECK_BOX,
  // FormFieldTypes.NUMBER_INPUT,
  // FormFieldTypes.DECISION_BOX,
  // FormFieldTypes.CALCULATIVE,
  // FormFieldTypes.PAYMENT,
];

export const constraintWithRequiredValue = [
  "IS",
  "IS_NOT",
  "CONTAINS",
  "NOT_CONTAINS",
  "STARTS_WITH",
  "ENDS_WITH",
  "MAXIMUM_TEXT_LENGTH",
  "LESS_THAN",
  "GREATER_THAN",
  "LESS_THAN_OR_EQUALS_TO",
  "GREATER_THAN_OR_EQUALS_TO",
  "MAXIMUM_DIGIT_LENGTH",
];
const commonFieldConstraint = {
  IS: "IS",
  IS_NOT: "IS_NOT",
  IS_EMPTY: "IS_EMPTY",
  IS_NOT_EMPTY: "IS_NOT_EMPTY",
};

export const constraintConfigs = {
  TEXT_INPUT: {
    ...commonFieldConstraint,
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    STARTS_WITH: "STARTS_WITH",
    ENDS_WITH: "ENDS_WITH",
    // MAXIMUM_TEXT_LENGTH :"MAXIMUM_TEXT_LENGTH",
  },
  TEXT_AREA: {
    ...commonFieldConstraint,
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    STARTS_WITH: "STARTS_WITH",
    ENDS_WITH: "ENDS_WITH",
    // MAXIMUM_TEXT_LENGTH :"MAXIMUM_TEXT_LENGTH",
  },
  CURRENCY: {
    ...commonFieldConstraint,
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
    // BETWEEN: "BETWEEN",
    // MAXIMUM_DIGIT_LENGTH = "MAXIMUM_DIGIT_LENGTH",
  },
  RATING: {
    ...commonFieldConstraint,
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
    // BETWEEN: "BETWEEN",
    // MAXIMUM_DIGIT_LENGTH = "MAXIMUM_DIGIT_LENGTH",
  },
  DATE_INPUT: {
    ...commonFieldConstraint,
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    // BETWEEN: "BETWEEN",
  },
  DATE_TIME_PICKER: {
    ...commonFieldConstraint,
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    // BETWEEN: "BETWEEN",
  },
  NUMBER_INPUT: {
    ...commonFieldConstraint,
    IS: "Is",
    IS_NOT: "Is Not",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
    BETWEEN: "BETWEEN",
  },
  TIME_PICKER: {
    ...commonFieldConstraint,
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    // BETWEEN: "BETWEEN",
  },
  DROPDOWN: {
    ...commonFieldConstraint,
    STARTS_WITH: "STARTS_WITH",
    ENDS_WITH: "ENDS_WITH",
    // Other Choice Is Not Empty
    // Is Any Of
    // Is None Of
  },
  MULTIPLE_CHOICES: {
    ...commonFieldConstraint,
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    //   Contains Any Of
    // Contains All Of
    // Contains None Of
  },
  LINEAR_SCALING: {
    IS: "Is",
    IS_NOT: "Is Not",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
    // BETWEEN: "BETWEEN",
  },
  PAYMENT: {
    IS: "Is",
    IS_NOT: "Is Not",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
    // BETWEEN: "BETWEEN",
  },
  CALCULATIVE: {
    IS: "Is",
    IS_NOT: "Is Not",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN_OR_EQUALS_TO: "LESS_THAN_OR_EQUALS_TO",
    GREATER_THAN_OR_EQUALS_TO: "GREATER_THAN_OR_EQUALS_TO",
  },
  CHECK_BOX: {
    IS: "Is",
    IS_NOT: "Is Not",
  },
  LOOKUP: {
    ...commonFieldConstraint,
  },
};

export const compareTimeWithAMPM = (
  startTime: string,
  endTime: string,
  operator: string
): boolean => {
  const convertTofulltime = (timeStr: string): string => {
    if (!timeStr) return "00:00";

    let time = timeStr.trim().toUpperCase();
    let [timePart, modifier] = time.split(" ");

    if (!modifier) {
      if (time.includes("AM")) {
        modifier = "AM";
        timePart = time.replace("AM", "").trim();
      } else if (time.includes("PM")) {
        modifier = "PM";
        timePart = time.replace("PM", "").trim();
      } else {
        return time;
      }
    }

    let [hours, minutes = "00"] = timePart
      .split(":")
      .map((part) => parseInt(part) || 0);

    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  try {
    const startTimefullhourFormat = convertTofulltime(startTime);
    const endTimefullhourFormat = convertTofulltime(endTime);

    const startDayTime = new Date(`1970-01-01T${startTimefullhourFormat}`);
    const endDayTime = new Date(`1970-01-01T${endTimefullhourFormat}`);

    switch (operator) {
      case allConstraint.GREATER_THAN:
        return startDayTime > endDayTime;
      case allConstraint.LESS_THAN:
        return startDayTime < endDayTime;
      case allConstraint.IS:
        return startDayTime.getTime() === endDayTime.getTime();
      case allConstraint.IS_NOT:
        return startDayTime.getTime() !== endDayTime.getTime();
      case allConstraint.GREATER_THAN_OR_EQUALS_TO:
        return startDayTime >= endDayTime;
      case allConstraint.LESS_THAN_OR_EQUALS_TO:
        return startDayTime <= endDayTime;
      default:
        return false;
    }
  } catch (error) {
    return false;
  }
};

export const getFieldTitle = (
  fieldsMap: IFieldsMap,
  fieldId: string
): string => {
  const fieldsData = fieldsMap[fieldId] || { title: "" };
  return fieldsData.title ?? "";
};

export const validateFieldRule = (
  ruleDetails: IFieldLevelRuleClient,
  fieldConditionMap: IFieldLevelRuleConditionMap
): boolean => {
  let isRuleDetailsCompleted = true;
  const fieldConditionIds = ruleDetails?.fieldConditionIds;
  const fieldActions: IFieldLevelRuleActionServer = ruleDetails?.action;
  interface IRequiredSubData {
    key: string;
    subdata: (string | IRequiredSubData)[];
  }

  const removeEmptyData = (data: any) => {
    const updatedData = {};
    Object.keys(data).forEach(function (key: string) {
      if (data[key] && typeof data[key] === "object") {
        updatedData[key] = removeEmptyData(data[key]);
      } else if (data[key] != "") {
        updatedData[key] = data[key];
      }
    });
    return updatedData;
  };
  const requiredfieldRuleData = [
    "ruleName",
    "logicalOperator",
    "fieldConditionIds",
  ];

  const updatedProfileData = removeEmptyData(ruleDetails);

  const validateFieldRuleData = (
    requiredfieldRuleData: (string | IRequiredSubData)[],
    updatedProfileData
  ) => {
    const filteredData: (string | IRequiredSubData)[] =
      requiredfieldRuleData?.filter((data: string | IRequiredSubData) => {
        if (typeof data == "string" && updatedProfileData[data]) return false;
        if (typeof data !== "string") {
          const { key, subdata } = data;
          if (updatedProfileData[key]) {
            Object.keys(updatedProfileData[key]).forEach(function (
              value: string,
              index: number
            ) {
              validateFieldRuleData(
                subdata,
                updatedProfileData[data.key][index]
              );
            });
            return false;
          }
        }
        return true;
      });

    if (filteredData.length > 0) {
      isRuleDetailsCompleted = false;
    }
  };

  const validateFieldConditions = (conditionIds: string[]) => {
    for (const index in conditionIds) {
      const conditionId = conditionIds[index];
      const fieldConditionData = { ...(fieldConditionMap[conditionId] ?? {}) };
      const { logicalOperator, fieldConditionIds, conditionType } =
        fieldConditionData;
      if (conditionType == ConditionType.user_field) {
        continue;
      }
      const updatedConditionData = removeEmptyData(fieldConditionData);
      const operator = fieldConditionData?.operator;
      const requiredFieldDataForCondition = [
        "operator",
        "fieldType",
        "fieldLocalId",
      ];
      if (operator && constraintWithRequiredValue.includes(operator)) {
        requiredFieldDataForCondition.push("value");
      }
      const requiredFieldDataForSubRule = [
        "logicalOperator",
        "fieldConditionIds",
      ];

      if (logicalOperator) {
        validateFieldRuleData(
          requiredFieldDataForSubRule,
          updatedConditionData
        );
      } else {
        validateFieldRuleData(
          requiredFieldDataForCondition,
          updatedConditionData
        );
      }
      validateFieldConditions(fieldConditionIds);
    }
  };
  const validateFieldActions = (fieldActions: IFieldLevelRuleActionServer) => {
    const { show, hide } = fieldActions;
    if (show.length == 0 && hide.length == 0) {
      isRuleDetailsCompleted = false;
    }
  };
  validateFieldRuleData(requiredfieldRuleData, updatedProfileData);
  validateFieldConditions(fieldConditionIds);
  validateFieldActions(fieldActions);
  return isRuleDetailsCompleted;
};

export const validatePageRule = (
  ruleDetails: IPageLevelRuleClient,
  pageConditionMap: IPageLevelRuleConditionMap
): boolean => {
  let isRuleDetailsCompleted = true;
  const pageConditionIds = ruleDetails?.pageConditionIds;
  const fieldActions: IPageLevelRuleAction = ruleDetails?.action;
  interface IRequiredSubData {
    key: string;
    subdata: (string | IRequiredSubData)[];
  }

  const removeEmptyData = (data: IPageLevelRuleConditionClient) => {
    const updatedData = {};
    Object.keys(data).forEach(function (key: string) {
      if (data[key] && typeof data[key] === "object") {
        updatedData[key] = removeEmptyData(data[key]);
      } else if (data[key] != "") {
        updatedData[key] = data[key];
      }
    });
    return updatedData;
  };
  const requiredfieldRuleData = [
    "ruleName",
    "logicalOperator",
    "pageConditionIds",
  ];

  const updatedProfileData = removeEmptyData(ruleDetails);

  const validatePageRuleData = (
    requiredfieldRuleData: (string | IRequiredSubData)[],
    updatedProfileData
  ) => {
    const filteredData: (string | IRequiredSubData)[] =
      requiredfieldRuleData?.filter((data: string | IRequiredSubData) => {
        if (typeof data == "string" && updatedProfileData[data]) return false;
        if (typeof data !== "string") {
          const { key, subdata } = data;
          if (updatedProfileData[key]) {
            Object.keys(updatedProfileData[key]).forEach(function (
              value: string,
              index: number
            ) {
              validatePageRuleData(
                subdata,
                updatedProfileData[data.key][index]
              );
            });
            return false;
          }
        }
        return true;
      });

    if (filteredData.length > 0) {
      isRuleDetailsCompleted = false;
    }
  };

  const validatePageConditions = (conditionIds: string[]) => {
    for (const index in conditionIds) {
      const conditionId = conditionIds[index];
      const fieldConditionData = { ...(pageConditionMap[conditionId] ?? {}) };
      const { logicalOperator, pageConditionIds } = fieldConditionData;
      const updatedConditionData = removeEmptyData(fieldConditionData);
      const operator = fieldConditionData?.operator;
      const requiredFieldDataForCondition = [
        "operator",
        "fieldType",
        "fieldLocalId",
        "subFormLocalId",
      ];
      if (operator && constraintWithRequiredValue.includes(operator)) {
        requiredFieldDataForCondition.push("value");
      }
      const requiredFieldDataForSubRule = [
        "logicalOperator",
        "pageConditionIds",
      ];

      if (logicalOperator) {
        validatePageRuleData(requiredFieldDataForSubRule, updatedConditionData);
      } else {
        validatePageRuleData(
          requiredFieldDataForCondition,
          updatedConditionData
        );
      }
      // validatePageConditions(pageConditionIds);
    }
  };
  const validatePageActions = (fieldActions: IPageLevelRuleAction) => {
    const show = fieldActions?.show || [];
    const skip = fieldActions?.skip || [];
    if (show?.length == 0 && skip?.length == 0) {
      isRuleDetailsCompleted = false;
    }
  };
  validatePageRuleData(requiredfieldRuleData, updatedProfileData);
  validatePageConditions(pageConditionIds);
  validatePageActions(fieldActions);
  return isRuleDetailsCompleted;
};

export const validateFormRule = (
  ruleDetails: IFormLevelRuleClient,
  formConditionMap: IFormLevelRuleConditionMap
): boolean => {
  let isRuleDetailsCompleted = true;
  const formConditionIds = ruleDetails?.formConditionIds;
  const formActions: IFormLevelRuleActionServer[] = ruleDetails?.formAction;
  interface IRequiredSubData {
    key: string;
    subdata: (string | IRequiredSubData)[];
  }

  const removeEmptyData = (data: IFormLevelRuleClient) => {
    const updatedData = {};
    Object.keys(data).forEach(function (key: string) {
      if (data[key] && typeof data[key] === "object") {
        updatedData[key] = removeEmptyData(data[key]);
      } else if (data[key] != "") {
        updatedData[key] = data[key];
      }
    });
    return updatedData;
  };
  const requiredfieldRuleData = [
    "ruleName",
    "logicalOperator",
    "formConditionIds",
  ];
  const updatedProfileData = removeEmptyData(ruleDetails);

  const validateFormRuleData = (
    requiredfieldRuleData: (string | IRequiredSubData)[],
    updatedProfileData
  ) => {
    const filteredData: (string | IRequiredSubData)[] =
      requiredfieldRuleData?.filter((data: string | IRequiredSubData) => {
        if (typeof data == "string" && updatedProfileData[data]) return false;
        if (typeof data !== "string") {
          const { key, subdata } = data;
          if (updatedProfileData[key]) {
            Object.keys(updatedProfileData[key]).forEach(function (
              value: string,
              index: number
            ) {
              validateFormRuleData(
                subdata,
                updatedProfileData[data.key][index]
              );
            });
            return false;
          }
        }
        return true;
      });

    if (filteredData.length > 0) {
      isRuleDetailsCompleted = false;
    }
  };

  const validateFormConditions = (conditionIds: string[]) => {
    for (const index in conditionIds) {
      const conditionId = conditionIds[index];
      const formConditionData = { ...(formConditionMap[conditionId] ?? {}) };
      const { logicalOperator, formConditionIds } = formConditionData;
      let updatedConditionData: any = removeEmptyData(formConditionData);
      const operator = formConditionData?.operator;
      const requiredFieldDataForCondition = [
        "operator",
        "fieldType",
        "fieldLocalId",
      ];
      if (operator && constraintWithRequiredValue.includes(operator)) {
        requiredFieldDataForCondition.push("value");
      }

      if (updatedConditionData.fieldValueType == ConditionType.form_field) {
        if (
          typeof updatedConditionData.value == "object" &&
          updatedConditionData.value &&
          "value" in updatedConditionData.value
        ) {
          const valueObject = updatedConditionData.value as {
            value: any;
          }; // Type assertion

          updatedConditionData = {
            ...updatedConditionData,
            value: valueObject.value,
          };
        }
      } else if (
        updatedConditionData?.fieldValueType == ConditionType.user_field ||
        updatedConditionData?.fieldValueType == ConditionType.system_fields
      ) {
        if (
          typeof updatedConditionData?.value === "object" &&
          updatedConditionData?.value !== null &&
          "value" in updatedConditionData?.value
        ) {
          const valueObject = updatedConditionData?.value as {
            value: any;
          }; // Type assertion
          updatedConditionData = {
            ...updatedConditionData,
            value: valueObject.value,
          };
        }
      }
      const requiredFieldDataForSubRule = [
        "logicalOperator",
        "formConditionIds",
      ];

      if (logicalOperator) {
        validateFormRuleData(requiredFieldDataForSubRule, updatedConditionData);
      } else {
        validateFormRuleData(
          requiredFieldDataForCondition,
          updatedConditionData
        );
      }
      // validateFormConditions(formConditionIds);
    }
  };

  const validateFormActions = (formActions: IFormLevelRuleActionServer[]) => {
    if (formActions?.length == 0) {
      isRuleDetailsCompleted = false;
    }
  };
  validateFormRuleData(requiredfieldRuleData, updatedProfileData);
  validateFormConditions(formConditionIds);
  validateFormActions(formActions);
  return isRuleDetailsCompleted;
};

export enum numberRulesConstraint {
  IS = "IS",
  IS_NOT = "IS_NOT",
  IS_EMPTY = "IS_EMPTY",
  IS_NOT_EMPTY = "IS_NOT_EMPTY",
  LESS_THAN = "LESS_THAN",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN_OR_EQUALS_TO = "LESS_THAN_OR_EQUALS_TO",
  GREATER_THAN_OR_EQUALS_TO = "GREATER_THAN_OR_EQUALS_TO",
  // BETWEEN = "BETWEEN",
  MAXIMUM_DIGIT_LENGTH = "MAXIMUM_DIGIT_LENGTH",
}
export enum numberRulesConstraintNames {
  IS = "Is",
  IS_NOT = "Is Not",
  IS_EMPTY = "Is Empty",
  IS_NOT_EMPTY = "Is Not Empty",
  LESS_THAN = "Less Than",
  GREATER_THAN = "Greater Than",
  LESS_THAN_OR_EQUALS_TO = "Less Than or Equal To",
  GREATER_THAN_OR_EQUALS_TO = "Greater Than or Equal To",
  // BETWEEN = "Between",
  MAXIMUM_DIGIT_LENGTH = "Maximum Digit Length",
}

export enum textRulesConstraint {
  IS = "IS",
  IS_NOT = "IS_NOT",
  IS_EMPTY = "IS_EMPTY",
  IS_NOT_EMPTY = "IS_NOT_EMPTY",
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS",
  STARTS_WITH = "STARTS_WITH",
  ENDS_WITH = "ENDS_WITH",
  MAXIMUM_TEXT_LENGTH = "MAXIMUM_TEXT_LENGTH",
}

export enum textRulesConstraintNames {
  IS = "Is",
  IS_NOT = "Is Not",
  IS_EMPTY = "Is Empty",
  IS_NOT_EMPTY = "Is Not Empty",
  CONTAINS = "Contains",
  NOT_CONTAINS = "Not Contains",
  STARTS_WITH = "Starts With",
  ENDS_WITH = "Ends With",
  MAXIMUM_TEXT_LENGTH = "Maximum Text Length",
}
export enum allConstraint {
  IS = "IS",
  IS_NOT = "IS_NOT",
  IS_EMPTY = "IS_EMPTY",
  IS_NOT_EMPTY = "IS_NOT_EMPTY",
  LESS_THAN = "LESS_THAN",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN_OR_EQUALS_TO = "LESS_THAN_OR_EQUALS_TO",
  GREATER_THAN_OR_EQUALS_TO = "GREATER_THAN_OR_EQUALS_TO",
  MAXIMUM_DIGIT_LENGTH = "MAXIMUM_DIGIT_LENGTH",
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS",
  STARTS_WITH = "STARTS_WITH",
  ENDS_WITH = "ENDS_WITH",
  MAXIMUM_TEXT_LENGTH = "MAXIMUM_TEXT_LENGTH",
}
export enum allConstraintNames {
  IS = "Is",
  IS_NOT = "Is Not",
  IS_EMPTY = "Is Empty",
  IS_NOT_EMPTY = "Is Not Empty",
  LESS_THAN = "Less Than",
  GREATER_THAN = "Greater Than",
  LESS_THAN_OR_EQUALS_TO = "Less Than or Equal To",
  GREATER_THAN_OR_EQUALS_TO = "Greater Than or Equal To",
  MAXIMUM_DIGIT_LENGTH = "Maximum Digit Length",
  CONTAINS = "Contains",
  NOT_CONTAINS = "Not Contains",
  STARTS_WITH = "Starts With",
  ENDS_WITH = "Ends With",
  MAXIMUM_TEXT_LENGTH = "Maximum Text Length",
}

export const emptyGroupedRule = {
  logicalOperator: "or",
  conditions: [
    {
      operator: "",
      value: "",
      fieldType: "",
      fieldLocalId: "",
    },
  ],
};

export const logicSwitchOptions = [
  {
    label: "AND",
    value: "and",
  },
  {
    label: " OR ",
    value: "or",
  },
];

export enum logicalSwitchOption {
  AND = "and",
  OR = "or",
}
export enum formFieldValueType {
  customField = "custom_field",
  formField = "form_field",
}

export const validateFieldRuleValue = (
  ruleValue: any,
  submissionValue: any,
  ruleType: string,
  submissionField?: string,
  fieldType?: any
): boolean => {
  let updatedSubmissionValue = submissionValue;
  if (fieldType === FormFieldTypes?.TIME_PICKER) {
    return compareTimeWithAMPM(submissionValue || "", ruleValue, ruleType);
  }
  if (submissionField == FormFieldTypes?.DATE_INPUT) {
    const inputDate = new Date(submissionValue);
    updatedSubmissionValue = `${(inputDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${inputDate
      .getDate()
      .toString()
      .padStart(2, "0")}/${inputDate.getFullYear()}`;
  }

  switch (ruleType) {
    case textRulesConstraint.IS:
      if (!checkIfIsConditionSatisfied(updatedSubmissionValue, ruleValue)) {
        return false;
      }
      break;
    case textRulesConstraint.IS_NOT:
      if (checkIfIsConditionSatisfied(updatedSubmissionValue, ruleValue)) {
        return false;
      }
      break;
    case textRulesConstraint.IS_EMPTY:
      if (!checkIsEmpty(updatedSubmissionValue)) return false;
      break;
    case textRulesConstraint.IS_NOT_EMPTY:
      if (checkIsEmpty(updatedSubmissionValue)) return false;
      break;
    case textRulesConstraint.CONTAINS:
      if (ruleValue) {
        if (typeof ruleValue == "string") {
          if (!updatedSubmissionValue?.includes(ruleValue)) {
            return false;
          }
        } else if (Array.isArray(ruleValue)) {
          for (const prefixValues of ruleValue) {
            if (!updatedSubmissionValue.includes(prefixValues.optionValue)) {
              return false;
            }
          }
          return true;
        } else if (typeof ruleValue == "object") {
          if (!updatedSubmissionValue.includes(ruleValue.optionValue)) {
            return false;
          }
        }
      }
      break;
    case textRulesConstraint.NOT_CONTAINS:
      if (ruleValue) {
        if (typeof ruleValue == "string") {
          if (updatedSubmissionValue?.includes(ruleValue)) {
            return false;
          } else {
            return true;
          }
        } else if (Array.isArray(ruleValue)) {
          for (const prefixValues of ruleValue) {
            if (updatedSubmissionValue.includes(prefixValues.optionValue)) {
              return false;
            }
          }
          return true;
        } else if (typeof ruleValue == "object") {
          if (updatedSubmissionValue.includes(ruleValue.optionValue)) {
            return false;
          } else {
            return true;
          }
        }
      }
    case textRulesConstraint.STARTS_WITH:
      if (ruleValue) {
        const prefix = ruleValue;
        if (typeof ruleValue == "string") {
          if (!updatedSubmissionValue.startsWith(prefix)) {
            return false;
          }
        } else if (Array.isArray(ruleValue)) {
          for (const prefixValues of ruleValue) {
            if (!updatedSubmissionValue.startsWith(prefixValues.optionValue)) {
              return false;
            }
          }
          return true;
        } else if (typeof ruleValue == "object") {
          if (!updatedSubmissionValue.startsWith(ruleValue.optionValue)) {
            return false;
          }
        }
      }
      break;

    case textRulesConstraint.ENDS_WITH:
      if (ruleValue) {
        const prefix = ruleValue;
        if (typeof ruleValue == "string") {
          if (!updatedSubmissionValue.endsWith(prefix)) {
            return false;
          }
        } else if (Array.isArray(ruleValue)) {
          for (const prefixValues of ruleValue) {
            if (!updatedSubmissionValue.endsWith(prefixValues.optionValue)) {
              return false;
            }
          }
          return true;
        } else if (typeof ruleValue == "object") {
          if (!updatedSubmissionValue.endsWith(ruleValue.optionValue)) {
            return false;
          }
        }
      }
      break;

    case textRulesConstraint.MAXIMUM_TEXT_LENGTH:
      if (
        typeof ruleValue === "string" &&
        updatedSubmissionValue?.length > parseInt(ruleValue)
      )
        return false;
      break;

    // case numberRulesConstraint.BETWEEN: //two textinput is required for between value
    // if (
    //   (parseInt(submissionValue) < parseInt(ruleValue?.min) &&
    //     ruleValue?.isIncludeMin) ||
    //   (parseInt(submissionValue) > parseInt(ruleValue?.max) &&
    //     ruleValue?.isIncludeMax)
    // )
    //   return false
    // break;
    case numberRulesConstraint.GREATER_THAN:
      if (fieldType == "DATE_INPUT") {
        if (
          typeof ruleValue === "string" &&
          new Date(updatedSubmissionValue) <= new Date(ruleValue)
        )
          return false;
      } else {
        if (
          typeof ruleValue === "string" &&
          parseInt(updatedSubmissionValue) <= parseInt(ruleValue)
        )
          return false;
        else if (
          typeof ruleValue === "number" &&
          parseInt(updatedSubmissionValue) <= ruleValue
        )
          return false;
      }
      break;
    case numberRulesConstraint.GREATER_THAN_OR_EQUALS_TO:
      if (
        typeof ruleValue === "string" &&
        parseInt(updatedSubmissionValue) < parseInt(ruleValue)
      )
        return false;
      else if (
        typeof ruleValue === "number" &&
        parseInt(updatedSubmissionValue) < ruleValue
      )
        return false;
      break;

    case numberRulesConstraint.LESS_THAN:
      if (fieldType == "DATE_INPUT") {
        if (
          typeof ruleValue === "string" &&
          new Date(updatedSubmissionValue) >= new Date(ruleValue)
        )
          return false;
      } else {
        if (
          typeof ruleValue === "string" &&
          parseInt(updatedSubmissionValue) >= parseInt(ruleValue)
        )
          return false;
        else if (
          typeof ruleValue === "number" &&
          parseInt(updatedSubmissionValue) >= ruleValue
        )
          return false;
      }
      break;

    case numberRulesConstraint.LESS_THAN_OR_EQUALS_TO:
      if (
        typeof ruleValue === "string" &&
        parseInt(updatedSubmissionValue) > parseInt(ruleValue)
      )
        return false;
      else if (
        typeof ruleValue === "number" &&
        parseInt(updatedSubmissionValue) > ruleValue
      )
        return false;
      break;
    case numberRulesConstraint.MAXIMUM_DIGIT_LENGTH:
      if (
        typeof ruleValue === "string" &&
        updatedSubmissionValue?.length > parseInt(ruleValue)
      )
        return false;
      break;

    default:
      break;
  }

  return true;
};

const checkIsEmpty = (value) => {
  if (value === null || value === undefined) {
    return true; // null or undefined is considered empty
  }

  if (typeof value === "string" && value.trim() === "") {
    return true; // empty string is considered empty
  }

  if (typeof value === "number" && isNaN(value)) {
    return true; // NaN is considered empty for numbers
  }

  if (Array.isArray(value) && value.length === 0) {
    return true; // empty array is considered empty
  }

  if (typeof value === "object" && Object.keys(value).length === 0) {
    return true; // empty object is considered empty
  }

  if (typeof value === "object" && allValuesEmpty(value)) {
    return true; // object with empty values is considered empty
  }

  return false; // non-empty value
};

// Helper function to check if all values in an object are empty
const allValuesEmpty = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && !checkIsEmpty(obj[key])) {
      return false;
    }
  }
  return true;
};

export const validateNumberRuleOnly = (
  //not used
  ruleValue: numberRulesConstraint,
  submissionValue: any,
  ruleType: string
): boolean => {
  switch (ruleType) {
    case numberRulesConstraint.IS:
      if (ruleValue !== submissionValue) {
        return false;
      }
      break;
    case numberRulesConstraint.IS_NOT:
      if (ruleValue == submissionValue) {
        return false;
      }
      break;
    case numberRulesConstraint.IS_EMPTY:
      if (typeof ruleValue === "string" && submissionValue?.length > 0)
        return false;
      break;

    case numberRulesConstraint.IS_NOT_EMPTY:
      if (typeof ruleValue === "string" && submissionValue?.length == 0)
        return false;
      break;
    // case numberRulesConstraint.BETWEEN: //two textinput is required for between value
    // if (
    //   (parseInt(submissionValue) < parseInt(ruleValue?.min) &&
    //     ruleValue?.isIncludeMin) ||
    //   (parseInt(submissionValue) > parseInt(ruleValue?.max) &&
    //     ruleValue?.isIncludeMax)
    // )
    //   return false
    // break;
    case numberRulesConstraint.GREATER_THAN:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) <= parseInt(ruleValue)
      )
        return false;
      break;
    case numberRulesConstraint.GREATER_THAN_OR_EQUALS_TO:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) < parseInt(ruleValue)
      )
        return false;
      break;

    case numberRulesConstraint.LESS_THAN:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) >= parseInt(ruleValue)
      )
        return false;
      break;

    case numberRulesConstraint.LESS_THAN_OR_EQUALS_TO:
      if (
        typeof ruleValue === "string" &&
        parseInt(submissionValue) > parseInt(ruleValue)
      )
        return false;
      break;

    case numberRulesConstraint.MAXIMUM_DIGIT_LENGTH:
      if (
        typeof ruleValue === "string" &&
        submissionValue?.length > parseInt(ruleValue)
      )
        return false;
      break;

    default:
      break;
  }

  return true;
};

export const checkIfIsConditionSatisfied = (
  submissionValue: any,
  ruleValue: any
): boolean => {
  if (Array.isArray(submissionValue) && submissionValue[0] != null) {
    return checkIfValueExist(ruleValue, submissionValue);
  } else if (typeof submissionValue === "string" && Array.isArray(ruleValue)) {
    for (const values of ruleValue) {
      if (
        values?.optionValue?.toUpperCase() == submissionValue?.toUpperCase()
      ) {
        return true;
      }
    }
    return false;
  } else if (
    typeof submissionValue === "string" &&
    typeof ruleValue == "object"
  ) {
    return (
      ruleValue?.optionValue?.toUpperCase() == submissionValue?.toUpperCase()
    );
  } else if (
    typeof submissionValue === "object" &&
    typeof ruleValue == "string"
  ) {
    return (
      ruleValue?.toUpperCase() == submissionValue?.optionValue?.toUpperCase()
    );
  } else if (
    typeof submissionValue === "string" &&
    typeof ruleValue == "string"
  ) {
    return ruleValue?.toUpperCase() == submissionValue?.toUpperCase();
  } else if (
    typeof submissionValue === "number" &&
    typeof ruleValue == "string"
  ) {
    return parseInt(ruleValue) == submissionValue;
  }
  const updatedRuleValue =
    ruleValue == "string" ? ruleValue?.toUpperCase() : ruleValue;
  const updatedSubmissionValue =
    submissionValue == "string" ? submissionValue?.toUpperCase() : ruleValue;
  const submissionOptionValue =
    submissionValue?.optionValue == "string"
      ? submissionValue?.optionValue?.toUpperCase()
      : submissionValue?.optionValue;
  return (
    updatedRuleValue == updatedSubmissionValue ||
    updatedRuleValue == submissionOptionValue?.toUpperCase()
  );
};
const checkIfValueExist = (searchString: any, arrayOfObjects: any): boolean => {
  let stringExists = arrayOfObjects.some((obj) =>
    Object.values(obj).some(
      (value) => typeof value === "string" && value.includes(searchString)
    )
  );
  if (Array.isArray(searchString)) {
    stringExists = arrayOfObjects.some((obj) =>
      Object.values(obj).some(
        (value) =>
          typeof value === "string" &&
          searchString.some((subStr) => value.includes(subStr))
      )
    );
  } else if (typeof searchString === "object" && !Array.isArray(searchString)) {
    stringExists = arrayOfObjects.some((obj) =>
      Object.values(obj).some(
        (value) =>
          typeof value === "string" &&
          Object.values<string>(searchString).some((subStr) =>
            value.includes(subStr)
          )
      )
    );
  }
  return stringExists;
};
export const checkIfIsNotConditionSatisfied = (
  submissionValue: any,
  ruleValue: string
): boolean => {
  return (
    (typeof submissionValue === "string" &&
      ruleValue.toUpperCase() === submissionValue.toUpperCase()) ||
    (submissionValue?.optionValue && ruleValue === submissionValue?.optionValue)
  );
};

export const getFilteredFieldsnameAndIdSelectorOfSubform = (
  fieldsMap: IFieldsMap,
  fieldIdsIgnore: string[],
  fieldTypesToIgnore: string[],
  formId: string
): IOption[] => {
  const filteredFieldOptions = [];
  Object.keys(fieldsMap).map((key: string) => {
    const fieldData: FieldProps = fieldsMap[key];
    const {
      title = "",
      localId,
      isSection,
      fieldType = "",
      fields,
      parentFormId,
      name = "",
    } = fieldData;

    const checkIsSection =
      isSection || fieldType == FormFieldTypes?.SECTION || false;
    if (
      !fieldIdsIgnore.includes(key) &&
      !checkIsSection &&
      !fieldTypesToIgnore.includes(fieldType) &&
      parentFormId == formId
    ) {
      filteredFieldOptions.push({
        content: name || title || "Untitled field",
        value: key,
        fieldType,
        parentFormId,
        localId,
        title: name || title || "Untitled field",
        // subtitle: fieldType || "",//can be used for better UX
      });
    }
  });
  return filteredFieldOptions;
};
const isSubCondition = (str: string) => {
  return str.startsWith("_sub-rule");
};
export const getUpdatedClientFieldRuleData = (
  data: IAdvancedRulesClient,
  activeFieldRuleIndex: number
): IAdvancedRulesClient => {
  let updatedFieldConditionMap: IFieldLevelRuleConditionMap =
    data?.fieldConditionMap;
  const activeFieldRule = data?.fieldRules[activeFieldRuleIndex];
  const subConditions: string[] = [];
  for (const conditionId of activeFieldRule.fieldConditionIds) {
    if (isSubCondition(conditionId)) {
      for (const fieldConditionId of updatedFieldConditionMap[conditionId]
        .fieldConditionIds) {
        subConditions.push(fieldConditionId);
      }
    } else {
      if (
        updatedFieldConditionMap[conditionId].fieldValueType ==
        ConditionType.form_field
      ) {
        if (
          typeof updatedFieldConditionMap[conditionId].value == "object" &&
          updatedFieldConditionMap[conditionId].value &&
          "value" in updatedFieldConditionMap[conditionId].value
        ) {
          const valueObject = updatedFieldConditionMap[conditionId].value as {
            value: any;
          }; // Type assertion

          updatedFieldConditionMap = {
            ...updatedFieldConditionMap,
            [conditionId]: {
              ...updatedFieldConditionMap[conditionId],
              value: valueObject.value,
            },
          };
        }
      } else if (
        updatedFieldConditionMap[conditionId].fieldValueType ==
          ConditionType.user_field ||
        updatedFieldConditionMap[conditionId].fieldValueType ==
          ConditionType.system_fields
      ) {
        if (
          typeof updatedFieldConditionMap[conditionId].value === "object" &&
          updatedFieldConditionMap[conditionId].value !== null &&
          "value" in updatedFieldConditionMap[conditionId].value
        ) {
          const valueObject = updatedFieldConditionMap[conditionId].value as {
            value: any;
          }; // Type assertion
          updatedFieldConditionMap = {
            ...updatedFieldConditionMap,
            [conditionId]: {
              ...updatedFieldConditionMap[conditionId],
              value: valueObject.value,
            },
          };
        }
      }
    }
  }

  if (subConditions.length > 0) {
    for (const conditionId of subConditions) {
      if (
        updatedFieldConditionMap[conditionId].fieldValueType ==
        ConditionType.form_field
      ) {
        if (
          typeof updatedFieldConditionMap[conditionId].value == "object" &&
          updatedFieldConditionMap[conditionId].value &&
          "value" in updatedFieldConditionMap[conditionId].value
        ) {
          const valueObject = updatedFieldConditionMap[conditionId].value as {
            value: any;
          }; // Type assertion

          updatedFieldConditionMap = {
            ...updatedFieldConditionMap,
            [conditionId]: {
              ...updatedFieldConditionMap[conditionId],
              value: valueObject.value,
            },
          };
        }
      } else if (
        updatedFieldConditionMap[conditionId].fieldValueType ==
          ConditionType.user_field ||
        updatedFieldConditionMap[conditionId].fieldValueType ==
          ConditionType.system_fields
      ) {
        if (
          typeof updatedFieldConditionMap[conditionId].value === "object" &&
          updatedFieldConditionMap[conditionId].value !== null &&
          "value" in updatedFieldConditionMap[conditionId].value
        ) {
          const valueObject = updatedFieldConditionMap[conditionId].value as {
            value: any;
          }; // Type assertion
          updatedFieldConditionMap = {
            ...updatedFieldConditionMap,
            [conditionId]: {
              ...updatedFieldConditionMap[conditionId],
              value: valueObject.value,
            },
          };
        }
      }
    }
  }

  const updatedFieldRule: IAdvancedRulesClient = {
    ...data,
    fieldConditionMap: updatedFieldConditionMap,
  };

  return updatedFieldRule;
};
